import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Pages/Home';
import Login from './Pages/Login';
import Dashboard from './Pages/Dashboard';
import Products_Main_Page from './Pages/mainpage_products';
import Settings from './Pages/settings';
import Barcoding from './Pages/barcoding';
import TeamManagement from'./Pages/team_management';
import CableManagement from './Pages/cable_management'
import AmazonProducts from './Pages/amazon_products';
import UsersManagement from './Pages/users_management';
import Conversion from './Pages/conversions';
import MEP_Solutions from './Pages/mep_solutions';
import ArchitecturalSolutions from './Pages/architecturale_solutions';
import CivilSolutions from './Pages/civil_solutions';
import ConstructionChemicals from './Pages/construction_chemicals';
import SustainableSolutions from './Pages/sustainable_solutions';
import HygenicSolutions from './Pages/hygienic_solutions';
import PowerHandTools from './Pages/power_hand_tools';
import WallProfiles from './Pages/Architectual_Finishing_Solutions/wall-profiles';
import Entrance_Matting_Systems from './Pages/Architectual_Finishing_Solutions/entrance-matting-system';
import ExpansionJointSystems from './Pages/Architectual_Finishing_Solutions/architectural-expansion-joints';
import AcessPanels_RoofHatches from './Pages/MEP_Solutions/access_pannels&roof_hatches';
import C_channel_strutsystem from "./Pages/MEP_Solutions/c_channel_strutsystem";
import Pipeclampshangers from "./Pages/MEP_Solutions/pipeclamps&hangers";
import PVC_Electrical from "./Pages/MEP_Solutions/pvc_electrical_conduits&accessories";
import MechanicalAnchoringSystems from './Pages/MEP_Solutions/mechanical_anchoring_systems';
import ChemicalAnchoringSystems from './Pages/MEP_Solutions/chemical_anchoring_systems';
import CableFasteningSystems from './Pages/MEP_Solutions/cable_fastenning_systems';
import LightweightFixings from './Pages/MEP_Solutions/light_weight_fixings';
import GalvanisedThreadedRods from './Pages/MEP_Solutions/galvanized_threaded_rods';
import HVAC_Thermal_Insulation from './Pages/MEP_Solutions/HVAC_Thermal_Insulation';
import Facade_Insulation from './Pages/MEP_Solutions/facade_insulation_fixings';
import MechanicalCladdingFixation from './Pages/Architectual_Finishing_Solutions/mechanical_cladding_fixation';
import WasteManagement from './Pages/Architectual_Finishing_Solutions/waste_management';
import Drywall_Ceiling from './Pages/Architectual_Finishing_Solutions/drywall&ceiling_profiles';
import Phenolic_Partition_System from './Pages/Architectual_Finishing_Solutions/phenolic-partition-systems';
import RaisedAccessFlooring from './Pages/Architectual_Finishing_Solutions/raised-access-floor-system';
import PedestalGridRaisedFloor from './Pages/Architectual_Finishing_Solutions/pedestal--grid-raised-floor';
import Handrails from './Pages/Architectual_Finishing_Solutions/handrails';
import ImpactProtectionSystem from './Pages/Architectual_Finishing_Solutions/impact-protection-systems';
import AcousticalDecorativeCeilings from './Pages/Architectual_Finishing_Solutions/acoustical--decorative-ceilings';
import GyProc_Systems_Solutions from './Pages/Architectual_Finishing_Solutions/gyproc-systems--solutions';
import PartitionSystems from './Pages/Architectual_Finishing_Solutions/partition-systems';
import ProjectManagement from "./Pages/project_management_main";
import KanbanBoard from "./Pages/KanbanBoard";
import Project from './Pages/projectdetails';
import GboardSystems from './Pages/Architectual_Finishing_Solutions/gboard-systems';
import GypsumBoardsAccessories from './Pages/Architectual_Finishing_Solutions/gypsum-boards--accessories';
import CementBoardsAccessoriesPage from './Pages/Architectual_Finishing_Solutions/cement-boards--accessories';
import InsulationSystemsPage from './Pages/Architectual_Finishing_Solutions/insulation-systems';
import ExpendedMetalsPlasterBeads from './Pages/Civil_Solutions/expanded-metals-plaster-beads';
import BlockLadderReinforcements from './Pages/Civil_Solutions/block-ladder-reinforcements';
import SteelLinesBlockWorkAccessories from './Pages/Civil_Solutions/steel-lintels--block-work-accessories';
import GeoSynthetics from './Pages/Civil_Solutions/geosynthetics';
import ConcreteAccessories from './Pages/Civil_Solutions/concrete-accessories';
import ExtrudedPolystyrene from './Pages/Civil_Solutions/extruded-polystyrene-thermal-insulation-boards';
import ExpandedPolystrene from './Pages/Civil_Solutions/expanded-polystrene-eps-thermal-insualtion-boards';
import PolyPropyleneProtectionBoard from './Pages/Civil_Solutions/polypropylene-protection-boards';
import BitumenBoards from './Pages/Civil_Solutions/bitumen-impregnated-fillers-and-protection-boards';
import LeadSheet from './Pages/Civil_Solutions/lead-sheet';
import Poluethylene from './Pages/Civil_Solutions/polyethylene-roll--film';
import BituminousProtectivePrimers from "./Pages/Civil_Solutions/bituminous-protective-primers";
import PvcWaterstop from "./Pages/Civil_Solutions/pvc-waterstop";
import FirestopSystems from "./Pages/construction_chemicals/firestop-systems";
import Adhesives from "./Pages/construction_chemicals/adhesives";
import WaterproofingMembranesSealants from "./Pages/construction_chemicals/waterproofing-membranes--sealants";
import ConstructionSealantsMoldingSystems from "./Pages/construction_chemicals/construction-sealants--molding-systems";
import TileAdhesivesAndGrouts from "./Pages/construction_chemicals/tile-adhesives-and-grouts";
import ConstructionFoams from "./Pages/construction_chemicals/construction-foams";
import AdhesivesSealantsConstructionChemicals
  from "./Pages/construction_chemicals/adhesives-sealants--construction-chemicals";
import TechnicalSupportPage from "./Pages/Technical_Support";
import ConstructionSpecialityChemicals from "./Pages/construction_chemicals/construction-speciality-chemicals";
import PowerToolsAccessories from "./Pages/power_hand_tools/power-tools--accessories";
import IndustrialTools from "./Pages/power_hand_tools/industrial-tools";
import CuttingGrindingAbrasiveDiscPage from "./Pages/power_hand_tools/cutting--grinding-abrasive-disc";
import HeavyDutyGeneratorsAirCompressorsPage from "./Pages/power_hand_tools/heavy-duty-generators--air-compressors";
import ProfessionalHandToolsEquipments from "./Pages/power_hand_tools/professional-hand-tools--equipments";
import HighQualityConstructionMachineries from "./Pages/power_hand_tools/high-quality-construction-machineries";
import GfrpConcreteReinforcement from "./Pages/sustainable_solutions/gfrp-concrete-reinforcement";
import CleanEnergySolutionsPage from "./Pages/sustainable_solutions/clean-energy-solutions";
import PaintsPage from "./Pages/sustainable_solutions/paints";
import UnitechSpecializedCoatingSolutionsPage from "./Pages/sustainable_solutions/specialized-coating-solutions";
import OilSpillRecovery from "./Pages/sustainable_solutions/oil-spill-recovery";
import OilSpillTackle from "./Pages/sustainable_solutions/oil-spill-tackle";
import HygienicWallCeilingPanels from "./Pages/hygienic_solutions/hygienic-wall--ceiling-panels";
import CommercialFlooringSolutions from "./Pages/hygienic_solutions/commercial-flooring-solutions";
import HygienicCleanroomSolutions from "./Pages/hygienic_solutions/hygienic-cleanroom-solutions";
import MyTickets from './Pages/MyTickets';
import AdminSupportIT from'./Pages/admin_support_IT';
import HygienicStainlessSteelTrimsAndSkirting
  from "./Pages/hygienic_solutions/hygienic-stainless-steel-trims-and-skirting";
import Quotations from './Pages/quotation';
import QuotationPage from "./Pages/quotation";
import Client_Management from './Pages/client_management';
import Metal_Ceiling_Grid_System from './Pages/Architectual_Finishing_Solutions/metal_ceiling_grid_system';

function App() {
  return (
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/products_main_page" element={<Products_Main_Page />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/barcoding" element={<Barcoding />} />
            <Route path="/team_management" element={<TeamManagement />} />
            <Route path="/cable_management" element={<CableManagement />} />
            <Route path="/amazon_products" element={<AmazonProducts />} />
            <Route path="/users_management" element={<UsersManagement />} />
            <Route path="/conversion" element={<Conversion />} />
            <Route path="/mep_solutions" element={<MEP_Solutions />} />
            <Route path="/architectural_solutions" element={<ArchitecturalSolutions />} />
            <Route path="/civil_solutions" element={<CivilSolutions />} />
            <Route path="/construction_chemicals" element={<ConstructionChemicals />} />
            <Route path="/sustainable_solutions" element={<SustainableSolutions />} />
            <Route path="/hygienic_solutions" element={<HygenicSolutions />} />
            <Route path="/power_tools" element={<PowerHandTools />} /> 
            <Route path="/wall_profiles" element={<WallProfiles />} />
            <Route path="/entrance_matting" element={<Entrance_Matting_Systems />} />
            <Route path="/expansion_joint_systems" element={<ExpansionJointSystems />} />
            <Route path="/access_pannels_roof_hatches" element={<AcessPanels_RoofHatches />}/>
            <Route path="/c_channel_strutsystem" element={<C_channel_strutsystem />} />
            <Route path="/pipeclampshangers" element={<Pipeclampshangers />} />
            <Route path="/pvc_electrical" element={<PVC_Electrical />} />
            <Route path="/mechanical_anchoring_systems" element={<MechanicalAnchoringSystems />} />
            <Route path="/chemical_anchoring_systems" element={<ChemicalAnchoringSystems />} />
            <Route path="/cable_fastenning_systems" element={<CableFasteningSystems />} />
            <Route path="/lightweight_fastenning_systems" element={<LightweightFixings />} />
            <Route path="/galvanized_threaded_rods" element={<GalvanisedThreadedRods />} />
            <Route path="/hvac_thermal_insulation" element={<HVAC_Thermal_Insulation />} />
            <Route path="/facade_insulation_fixings" element={<Facade_Insulation />} />
            <Route path="/mechanical_cladding_fixation" element={<MechanicalCladdingFixation />} />
            <Route path="/waste_management" element={<WasteManagement />} />
            <Route path="/drywall_ceiling" element={<Drywall_Ceiling />} />
            <Route path="/phenolic_partition_system" element={<Phenolic_Partition_System />} />
            <Route path="/raised_access_flooring" element={<RaisedAccessFlooring />} />
            <Route path="/pedestal_grid_raised_floor" element={<PedestalGridRaisedFloor />} />
            <Route path="/handrails" element={<Handrails />} />
            <Route path="/impact_protection_systems" element={<ImpactProtectionSystem />} />
            <Route path="/acoustical_decorative_ceilings" element={<AcousticalDecorativeCeilings />} />
            <Route path="/gyproc_systems_solutions" element={<GyProc_Systems_Solutions />} />
            <Route path="/partition_systems" element={<PartitionSystems />} />
            
            {/* Project Management Routes */}
            <Route path="/projects" element={<ProjectManagement />} />
            <Route path="/project_management" element={<ProjectManagement />} />
            <Route path="/project_management/:projectId" element={<Project />} />
            <Route path="/project/:projectId" element={<Project />} />
            <Route path="/kanban-board" element={<KanbanBoard />} />
            <Route path='/gboard-systems' element={<GboardSystems />} />
            <Route path="/gypsum-boards-accessories" element={<GypsumBoardsAccessories />} />
            <Route path="/cement-boards-accessories" element={<CementBoardsAccessoriesPage />} />
            <Route path="/insulation-systems" element={<InsulationSystemsPage />} />
            <Route path="/expanded-metals-plaster-beads" element={<ExpendedMetalsPlasterBeads />} />
            <Route path="/block-ladder-reinforcements" element={<BlockLadderReinforcements />} />
            <Route path="/steel-lintels-block-work-accessories" element={<SteelLinesBlockWorkAccessories />} />
            <Route path="/geosynthetics" element={<GeoSynthetics />} />
            <Route path="/concrete-accessories" element={<ConcreteAccessories />} />
            <Route path="/extruded_polystyrene" element={<ExtrudedPolystyrene />} />
            <Route path="/expanded_polystyrene" element={<ExpandedPolystrene />} />
            <Route path="/polypropylene" element={<PolyPropyleneProtectionBoard/>}/>
            <Route path="/bitumen_boards" element={<BitumenBoards />} />
            <Route path="/lead_sheets" element={<LeadSheet/>}/>
            <Route path="/polyethylene" element={<Poluethylene/>}/>
            <Route path="/bituminous" element={<BituminousProtectivePrimers/>}/>
            <Route path="/pvc-waterstop" element={<PvcWaterstop/>}/>
            <Route path="/firestop_systems" element={<FirestopSystems />}/>
            <Route path="/adhesives" element={<Adhesives />}/>
            <Route path="/waterproofing" element={<WaterproofingMembranesSealants/>}/>
            <Route path="/construction_molding_system" element={<ConstructionSealantsMoldingSystems/>}/>
            <Route path="tile_adhesives_grouts" element={<TileAdhesivesAndGrouts/>}/>
            <Route path="/construction_foams" element={<ConstructionFoams />}/>
            <Route path="/adhesives_sealants_construction_chemicals" element={<AdhesivesSealantsConstructionChemicals />}/>
            <Route path="/technical_support" element={<TechnicalSupportPage/>}/>
            <Route path="/construction_speciality_chemicals" element={<ConstructionSpecialityChemicals />}/>
            <Route path="/power_tools_page" element={<PowerToolsAccessories />}/>
            <Route path="/industrial_tools" element={<IndustrialTools />}/>
            <Route path="/cutting-gridding_disc" element={<CuttingGrindingAbrasiveDiscPage/>}/>
            <Route path="/professional_hand_tools" element={<ProfessionalHandToolsEquipments/>}/>
            <Route path="/heavy_duty" element={<HeavyDutyGeneratorsAirCompressorsPage/>}/>
            <Route path="/high_quality_machinery" element={<HighQualityConstructionMachineries/>}/>
            <Route path="/gfrp_quality_reinforcement" element={<GfrpConcreteReinforcement/>}/>
            <Route path="/clean_energy_solutions" element={<CleanEnergySolutionsPage/>}/>
            <Route path="/paints_page" element={<PaintsPage/>}/>
            <Route path="/specailized_coating_solutions" element={<UnitechSpecializedCoatingSolutionsPage/>}/>
            <Route path="/oil_spill_recovery" element={<OilSpillRecovery/>}/>
            <Route path="/oil_spill_tackle" element={<OilSpillTackle/>}/>
            <Route path="/hygienic_wall_ceiling_panels" element={<HygienicWallCeilingPanels/>}/>
            <Route path="/commercial_flooring_solutions" element={<CommercialFlooringSolutions/>}/>
            <Route path="/hygienic_cleanroom_solutions" element={<HygienicCleanroomSolutions/>}/>
            <Route path="/mytickets" element={<MyTickets/>}/>
            <Route path="/admin_support_it" element={<AdminSupportIT/>}/>
            <Route path="/hygienic_stainless_steel_trims_skirting" element={<HygienicStainlessSteelTrimsAndSkirting/>}/>
            <Route path="/quotations" element={<QuotationPage/>}/>
            <Route path="/clients" element={<Client_Management />} />
            <Route path="/metal_ceiling_grid_system" element={<Metal_Ceiling_Grid_System />} />
        </Routes>
      </Router>
  );
}

export default App;
